const vipRouter = [
  {
    path: '/vip',
    name: 'VipIndex',
    component: () => import('@/views/vip/index')
  },
  {
    path: '/vip/scheme',
    name: 'VipScheme',
    component: () => import('@/views/vip/scheme')
  },
  {
    path: '/vip/apply/success',
    name: 'VipApplySuccess',
    component: () => import('@/views/vip/apply_success')
  },
  {
    path: '/vip/pay/success',
    name: 'VipPaySuccess',
    component: () => import('@/views/vip/pay_success')
  },
  {
    path: '/vip/user',
    name: 'VipUser',
    component: () => import('@/views/vip/user')
  }
]

export default vipRouter



// WEBPACK FOOTER //
// ./src/router/modules/vip.js